/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Showcase_Use_Case_DevelopmentInputs */



/**
* | output |
* | --- |
* | "Coding" |
*
* @param {Model_Showcase_Use_Case_DevelopmentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_showcase_use_case_development = /** @type {((inputs?: Model_Showcase_Use_Case_DevelopmentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Showcase_Use_Case_DevelopmentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Coding")
	return /** @type {LocalizedString} */ ("Coding")
});